import { TNestedGenericId } from '../types'

export type TNotifyConfig = {
    firebaseConfig: {
        apiKey: string
        authDomain: string
        databaseURL: string
        refreshJWTUrl: string
    }
    jobSeekerUrl: string
    baseMsUrl: string
}

export type TUser = {
    userName: string
    userId: number
    firstName: string
    lastName: string
    profilePicture: string | null
    jobTitle: string
    industryList?: number[]
    jobFunction?: TNestedGenericId[]
    jobLevelId?: number[]
    accessToken?: string
    refreshToken?: string
}

export enum ENotificationTypes {
    EXPIRE_JOB = 1,
    EMPLOYER_VIEW_PROFILE = 3,
    OLD_EMPLOYER_VIEW_PROFILE = 4, // Remove
    UNKNOWN_NOTIFY = 6,
    EMPLOYER_VIEW_APPLICATION = 8,
    EMPLOYER_CHANGE_APPLICATION_STATUS = 11,
    JOB_INVITATION = 20
}

export const ALLOW_NOTIFY_TYPE = [1, 3, 8, 11, 20]

export enum EApplicationStatusTypes {
    EMPLOYER_VIEWED_YOUR_APPLICATION = 3,
    EMPLOYER_DECLINED_YOUR_APPLICATION = 4,
    EMPLOYER_SELECTED_YOUR_APPLICATION = 6
}

export type TNotificationItem = {
    notifyKey: string
    companyLogo: string
    companyName: string
    employerId: number
    isAttached: number
    isRead: number
    isShowLogo: boolean
    noOfEmployerViews: number
    resumeId: number
    sentDate: number
    source: number
    statusId: string
    type: ENotificationTypes
    userId: number
    viewDate: number
    jobTitle: string
    expiredDate: number
    aliasEn: string
    aliasVi: string
    alias: string
    content: string
    jobInvitationId: number
}
